export class APIURL {
    //static SERVER_URL = 'http://15.207.14.60:2050/';
    static SERVER_URL = 'https://pillarblocks.com:2050/';
    //static SERVER_URL = 'http://localhost:2050/';
    static WEBSITE_URL = 'https://pillarblocks.com';
    static STORAGE_URL = 'https://d1tcpzzcuv60ry.cloudfront.net/';
}